import { render, staticRenderFns } from "./StudyResourcePreview.vue?vue&type=template&id=13b71054&scoped=true&"
import script from "./StudyResourcePreview.vue?vue&type=script&lang=js&"
export * from "./StudyResourcePreview.vue?vue&type=script&lang=js&"
import style0 from "./StudyResourcePreview.vue?vue&type=style&index=0&id=13b71054&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b71054",
  null
  
)

export default component.exports